export default __webpack_public_path__ + "static/media/IF_MyStrengths_StrengthDesc_02.06bb5e03.jpg";